// extracted by mini-css-extract-plugin
export default {"collapsePanel":"step-edition-infos_collapsePanel__tIAWA","ant-collapse-header-text":"step-edition-infos_ant-collapse-header-text__omYk8"};